import api from './utilPartner';

const controller = 'Pessoa';
const url = process.env.VUE_APP_ROOT_API + controller;
export default Object.assign({}, api.GetCrud(controller, null), {
  LocalizarRegistro: function (dto) {
    return api.Axios.GetParams(url + '/LocalizarRegistro', dto);
  },
  ListarParceiros: function () {
    return api.Axios.GetParams(url + '/ListarParceiros');
  },
  ListarClientes: function (dto) {
    return api.Axios.GetParams(url + '/ListarClientes', dto);
  },
  LocalizarCliente: function (dto) {
    return api.Axios.GetParams(url + '/LocalizarCliente', dto);
  }
});
